import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import TopicPage from "../pages/topic/page";
import DetailPage from "../pages/detail/page";
import SearchPage from "../pages/search/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category/:categoryName",
        element: <CategoryPage />,
      },
      {
        path: "topic/:topicId",
        element: <TopicPage />,
      },
      {
        path: "detail/:newsId",
        element: <DetailPage />,
      },
      {
        path: "search",
        element: <SearchPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "contact",
        element: <ContactPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;